import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import pure from 'recompose/pure';
import Chip from 'material-ui/Chip';

import { orange200 } from 'material-ui/styles/colors';


const styles = {
  display: 'flex',
  flexWrap: 'wrap',
};

const MultipleChipsField = ({ source, record = {}, elStyle = { margin: 4, backgroundColor: orange200 } }) => {
  let chips = null;
  if (record) {
    chips = get(record, source)
  }
  return (
    <div style={styles}>
      {chips && chips.map((item, i) =>
        <Chip
          key={i}
          backgroundColor={elStyle.backgroundColor}
          style={elStyle}
        >
          {item}
        </Chip>)}
    </div>
  );
};


MultipleChipsField.propTypes = {
  addLabel: PropTypes.bool,
  elStyle: PropTypes.object,
  label: PropTypes.string,
  source: PropTypes.string.isRequired,
  record: PropTypes.object,
};

const PureMultipleChipsField = pure(MultipleChipsField);

PureMultipleChipsField.defaultProps = {
  addLabel: true,
};

export default PureMultipleChipsField;



// WEBPACK FOOTER //
// ./src/components/field/MultipleChipsField.js